import * as Yup from 'yup';

export const STOCK_CLASS_TYPE = {
  COMMON: 1,
  PREFERRED: 2,
} as const;

export const STOCK_CLASS_TYPE_LABELS: Record<number, string> = {
  [STOCK_CLASS_TYPE.COMMON]: 'Common',
  [STOCK_CLASS_TYPE.PREFERRED]: 'Preferred',
};

export const stockClassTypeOptions = [
  { label: STOCK_CLASS_TYPE_LABELS[STOCK_CLASS_TYPE.COMMON], value: STOCK_CLASS_TYPE.COMMON },
  { label: STOCK_CLASS_TYPE_LABELS[STOCK_CLASS_TYPE.PREFERRED], value: STOCK_CLASS_TYPE.PREFERRED },
];

export const PARTICIPATION_TYPE = {
  NON_PARTICIPATING: 1,
  FULLY_PARTICIPATING: 2,
  PARTICIPATING_WITH_CAP: 3,
} as const;

export const PARTICIPATION_TYPE_LABELS: Record<number, string> = {
  [PARTICIPATION_TYPE.NON_PARTICIPATING]: 'Non-Participating',
  [PARTICIPATION_TYPE.FULLY_PARTICIPATING]: 'Fully Participating',
  [PARTICIPATION_TYPE.PARTICIPATING_WITH_CAP]: 'Participating with a Cap',
};

export const stockClassParticipationDefaults = {
  participationType: '',
  participationCapMultiple: '',
};

const emptyToUndefined = (value: unknown, originalValue: unknown) =>
  originalValue === '' || originalValue === null || originalValue === undefined ? undefined : value;

export const stockClassParticipationValidation = {
  participationType: Yup.number()
    .transform(emptyToUndefined)
    .when('classType', {
      is: STOCK_CLASS_TYPE.PREFERRED,
      then: (schema) => schema.required('Participation Type is required for Preferred stock'),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
  participationCapMultiple: Yup.number()
    .transform(emptyToUndefined)
    .when('participationType', {
      is: PARTICIPATION_TYPE.PARTICIPATING_WITH_CAP,
      then: (schema) => schema.required('Participation Cap Multiple is required'),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
};

export const clearParticipationOnCommonClassType = (
  setFieldValue: (field: string, value: unknown) => void,
  fieldPrefix: string,
  index: number
): void => {
  setFieldValue(`${fieldPrefix}.${index}.participationType`, '');
  setFieldValue(`${fieldPrefix}.${index}.participationCapMultiple`, '');
};

export const clearParticipationCapWhenNotCapped = (
  setFieldValue: (field: string, value: unknown) => void,
  fieldPrefix: string,
  index: number,
  participationType: number | string
): void => {
  if (Number(participationType) !== PARTICIPATION_TYPE.PARTICIPATING_WITH_CAP) {
    setFieldValue(`${fieldPrefix}.${index}.participationCapMultiple`, '');
  }
};

export const mapParticipationFieldsToApi = (row: {
  classType: number | string;
  participationType?: number | string;
  participationCapMultiple?: number | string;
}): {
  participationType?: number;
  participationCapMultiple?: number;
} => {
  if (Number(row.classType) !== STOCK_CLASS_TYPE.PREFERRED) {
    return {};
  }

  return {
    participationType: row.participationType ? Number(row.participationType) : undefined,
    participationCapMultiple:
      Number(row.participationType) === PARTICIPATION_TYPE.PARTICIPATING_WITH_CAP && row.participationCapMultiple
        ? Number(row.participationCapMultiple)
        : undefined,
  };
};
